/**
 * Workspace Service REST API
 *
 * Contact: ContactRequests@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { CloneWindowsResponse } from '../model/cloneWindowsResponse';
// @ts-ignore
import { Window } from '../model/window';
// @ts-ignore
import { WindowUpdate } from '../model/windowUpdate';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { WorkspacesAPIConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';
import {
    PublicWindowControllerServiceInterface,
    ClonePublicWindowRequestParams,
    CreatePublicWindowRequestParams,
    DeletePublicWindowRequestParams,
    GetPublicWindowsOfTabRequestParams,
    MovePublicWindowRequestParams,
    UpdatePublicWindowRequestParams
} from './publicWindowController.serviceInterface';

@Injectable({
    providedIn: 'root'
})
export class PublicWindowControllerService extends BaseService implements PublicWindowControllerServiceInterface {
    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string | string[],
        @Optional() configuration?: WorkspacesAPIConfiguration
    ) {
        super(basePath, configuration);
    }

    /**
     * Clone window
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clonePublicWindow(
        requestParameters: ClonePublicWindowRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<CloneWindowsResponse>;
    public clonePublicWindow(
        requestParameters: ClonePublicWindowRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<CloneWindowsResponse>>;
    public clonePublicWindow(
        requestParameters: ClonePublicWindowRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<CloneWindowsResponse>>;
    public clonePublicWindow(
        requestParameters: ClonePublicWindowRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling clonePublicWindow.');
        }
        const targetTabId = requestParameters?.targetTabId;

        let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetTabId, 'targetTabId');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/windows/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/clone`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CloneWindowsResponse>('post', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            params: localVarQueryParameters,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Create window
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createPublicWindow(
        requestParameters: CreatePublicWindowRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Window>;
    public createPublicWindow(
        requestParameters: CreatePublicWindowRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Window>>;
    public createPublicWindow(
        requestParameters: CreatePublicWindowRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Window>>;
    public createPublicWindow(
        requestParameters: CreatePublicWindowRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const window = requestParameters?.window;
        if (window === null || window === undefined) {
            throw new Error('Required parameter window was null or undefined when calling createPublicWindow.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/windows`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Window>('post', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: window,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Delete window
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deletePublicWindow(
        requestParameters: DeletePublicWindowRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<any>;
    public deletePublicWindow(
        requestParameters: DeletePublicWindowRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<any>>;
    public deletePublicWindow(
        requestParameters: DeletePublicWindowRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<any>>;
    public deletePublicWindow(
        requestParameters: DeletePublicWindowRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deletePublicWindow.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/windows/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Get windows of a tab
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPublicWindowsOfTab(
        requestParameters: GetPublicWindowsOfTabRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Array<Window>>;
    public getPublicWindowsOfTab(
        requestParameters: GetPublicWindowsOfTabRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Array<Window>>>;
    public getPublicWindowsOfTab(
        requestParameters: GetPublicWindowsOfTabRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Array<Window>>>;
    public getPublicWindowsOfTab(
        requestParameters: GetPublicWindowsOfTabRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const tabId = requestParameters?.tabId;
        if (tabId === null || tabId === undefined) {
            throw new Error('Required parameter tabId was null or undefined when calling getPublicWindowsOfTab.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/tabs/${this.configuration.encodeParam({ name: 'tabId', value: tabId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/windows`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<Window>>('get', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Move window
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public movePublicWindow(
        requestParameters: MovePublicWindowRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<CloneWindowsResponse>;
    public movePublicWindow(
        requestParameters: MovePublicWindowRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<CloneWindowsResponse>>;
    public movePublicWindow(
        requestParameters: MovePublicWindowRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<CloneWindowsResponse>>;
    public movePublicWindow(
        requestParameters: MovePublicWindowRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling movePublicWindow.');
        }
        const targetTabId = requestParameters?.targetTabId;
        if (targetTabId === null || targetTabId === undefined) {
            throw new Error('Required parameter targetTabId was null or undefined when calling movePublicWindow.');
        }

        let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetTabId, 'targetTabId');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/windows/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/move`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CloneWindowsResponse>('post', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            params: localVarQueryParameters,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Update window
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePublicWindow(
        requestParameters: UpdatePublicWindowRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Window>;
    public updatePublicWindow(
        requestParameters: UpdatePublicWindowRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Window>>;
    public updatePublicWindow(
        requestParameters: UpdatePublicWindowRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Window>>;
    public updatePublicWindow(
        requestParameters: UpdatePublicWindowRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updatePublicWindow.');
        }
        const windowUpdate = requestParameters?.windowUpdate;
        if (windowUpdate === null || windowUpdate === undefined) {
            throw new Error('Required parameter windowUpdate was null or undefined when calling updatePublicWindow.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/windows/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Window>('put', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: windowUpdate,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }
}
